import React from "react";
import calc from "../../../utils/calculation";

import lbl from "../../../data/Labels.json";

const FinanceSummaryCard = ({ data, payables, payments }) => {

  let mPayable = calc.getTotal(payables, "amount");
  let mPaid = calc.getTotal(payments, "amount");
  let balance = (mPayable - mPaid).toFixed(2);

  return (
      <div className="summary-card flex">
        <div className="card-wrapper">
          <p className="summary-title">{"خلاصه عمومی"}</p>
          <ul>
            <li>
              <b>{data?.summary?.opening_balance || 0}</b>
              <span>{lbl.OpeningBalance}</span>
            </li>
            <li>
              <b>{data?.summary?.total_payable || 0}</b>
              <span>{lbl.Payable}</span>
            </li>

            <li>
              <b>{data?.summary?.total_paid || 0}</b>
              <span>{lbl.Paid}</span>
            </li>
          </ul>
        </div>
        <div className="card-wrapper">
          <p className="summary-title">{"خلاصه نیم سال"}</p>
          <ul>
            <li>
              <b>{mPayable || 0}</b>
              <span>{lbl.Payable}</span>
            </li>
            <li>
              <b>{mPaid || 0}</b>
              <span>{lbl.Paid}</span>
            </li>

            <li>
              <b>{balance || 0}</b>
              <span>{lbl.Balance}</span>
            </li>
          </ul>
        </div>
      </div>
  );
};

export default FinanceSummaryCard;
